import { useEffect, useState } from "react";
import React from "react";
import { api } from "../../../_services/api.service";
import GeneralGrid from "../../../Components/GeneralGrid";
import moment from "moment";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import { userService } from "../../../_services/user.service";

const UsersCard = ({
  partnerScenarioId,
  partnerId,
  isSurvey,
  users,
  setUsers,
  history,
  toggleAddUserModal,
  partner,
}) => {
  const currentUser = userService.getLoggedInUser();
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (partner != undefined && partner != null) {
      setColumns([
        {
          dataField: "firstName",
          text: "Name",
          headerStyle: () => {
            return { width: "25%" };
          },
          sort: true,
          formatter: (cellContent, row) => {
            return (
              <a
                key={row.userID}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  goToDetails(row.userID);
                }}
              >
                {row.firstName + " " + row.lastName}
              </a>
            );
          },
        },

        {
          dataField: "email",
          text: "Email",
          headerStyle: () => {
            return { width: "25%" };
          },
          sort: true,
        },
        {
          dataField: "userSubscriptionStartDT",
          text: "Start Date",
          headerStyle: () => {
            return { width: "25%" };
          },
          formatter: (cellContent, row) => {
            return cellContent ? moment(cellContent).format("L") : "";
          },
        },
        {
          dataField: "scenarioCount",
          text: isSurvey
            ? "# Surveys"
            : `# ${partner?.decisionName ?? "Decision"}`,
          headerStyle: () => {
            return { width: "25%" };
          },
          sort: true,
        },
      ]);
    }
  }, [partner]);

  const goToDetails = (userId) => {
    history.push({
      pathname: `/fullprofile/${userId}`,
    });
  };

  const defaultSorted = [
    {
      dataField: "lastName",
      order: "asc",
    },
  ];

  const options = {
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
    ],
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const handleUserSelect = (row, isSelect) => {
    setUsers(
      users.map((x) => {
        if (x.userID == row.userID) {
          x.isSelected = isSelect;
        }
        return x;
      })
    );
  };

  const handleUserSelectAll = (isSelect, rows) => {
    setUsers(
      users.map((x) => {
        x.isSelected = isSelect;
        return x;
      })
    );
  };

  return (
    <div>
     
      {columns.length > 0 && (
        <GeneralGrid
          title=""
          keyField="userID"
          defaultSortedColumn="firstName"
          dataSource={users}
          filterColumns={["firstName", "lastName"]}
          columns={columns}
          defaultSorted={defaultSorted}
          options={options}
          buttonText="Add User"
          showAddBtn={true}
          //   errorText={errorText}
          onAdd={() => {
            toggleAddUserModal();
          }}
          selectRow={{
            mode: "checkbox",
            clickToSelect: true,
            onSelect: handleUserSelect,
            onSelectAll: handleUserSelectAll,
          }}
        />
      )}
    </div>
  );
};

export default UsersCard;
